(function($) {

    $(document).ready(function(){
        process_map_points();
    });

    $(window).on('resize',function(){
        process_map_points();
    });

    function process_map_points() {
        if($('.map-container').length) {

            $.each($('.map-container .map-point'),function(i,e) {
                $top_position = $(this).data('positionTop');
                $left_position = $(this).data('positionLeft');

                if($(window).width() < 1200) {
                    $top_position = $(this).data('positionTabletTop');
                    $left_position = $(this).data('positionTabletLeft');    
                }

                $(this).css('top', $top_position + '%');
                $(this).css('left', $left_position + '%');
                $(this).css('opacity', 1);
            });  
        }
    }

})(jQuery);